import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, getSortState, translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';
import { PageFilters } from 'app/shared/components/page-filters/PageFilters';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { ISearchTypes } from 'app/shared/interfaces/searchTypesInterface';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { Loading } from 'app/shared/util/loading';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC } from 'app/shared/util/pagination.constants';
import { getEntities } from './device-truck-implement.reducer';

export const DeviceTruckImplement = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const totalItems = useAppSelector(state => state.deviceTruckImplement.totalItems);
  const loading = useAppSelector(state => state.deviceTruckImplement.loading);

  const deviceTruckImplementList = useAppSelector(state => state.deviceTruckImplement.entities);
  const [nameSearch, setNameSearch] = useState<string>('');

  const searchTypes: ISearchTypes[] = [
    {
      label: translate('fleetSenseApp.deviceTruckImplement.searchLabel'),
      placeholder: translate('fleetSenseApp.deviceTruckImplement.search'),
      value: nameSearch,
      setValue: setNameSearch,
    },
  ];

  const getAllEntities = useCallback(() => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        nameSearch,
      })
    );
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  }, [paginationState]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const setActivePage = () => {
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
  };

  useEffect(() => {
    getAllEntities();
  }, [getAllEntities]);

  const { match } = props;

  return (
    <Fragment>
      <PageHeader
        headingId="device-truck-implement-heading"
        headingDataCy="DeviceTruckImplementHeading"
        contentKey="fleetSenseApp.deviceTruckImplement.home.title"
        buttonTextKey="fleetSenseApp.deviceTruckImplement.buttonMcdFirmware"
        match={match}
        urlButton={`mcd-firmware?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
      />

      <PageFilters setActivePage={setActivePage} searchTypes={searchTypes} showFilters={['filters']} />

      {!loading ? (
        <Table responsive>
          <thead>
            <tr>
              <DoNotShowInProduction>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fleetSenseApp.deviceTruckImplement.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
              </DoNotShowInProduction>
              <th className="hand" onClick={sort('serial')}>
                <Translate contentKey="fleetSenseApp.deviceTruckImplement.serial">Serial</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('firmware')}>
                <Translate contentKey="fleetSenseApp.deviceTruckImplement.firmware">Firmware</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('device.model')}>
                <Translate contentKey="fleetSenseApp.deviceTruckImplement.device">Device</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('truckImplement.licensePlate')}>
                <Translate contentKey="fleetSenseApp.deviceTruckImplement.truckImplement">Truck Implement</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('imei')}>
                <Translate contentKey="fleetSenseApp.deviceTruckImplement.imei">Imei</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('iccid')}>
                <Translate contentKey="fleetSenseApp.deviceTruckImplement.iccid">Iccid</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {deviceTruckImplementList.map((deviceTruckImplement, i) => (
              <tr key={`entity-${i}`} data-cy="entityTable">
                <DoNotShowInProduction>
                  <td>
                    <Button tag={Link} to={`${match.url}/${deviceTruckImplement.id}`} color="link" size="sm">
                      {deviceTruckImplement.id}
                    </Button>
                  </td>
                </DoNotShowInProduction>
                <td>{deviceTruckImplement.serial}</td>
                <td>{deviceTruckImplement.firmware}</td>
                <td>{deviceTruckImplement.device.model}</td>
                <td>
                  <Button tag={Link} to={`/dashboards/truck-implement/${deviceTruckImplement.truckImplement.id}`} color="link" size="sm">
                    {deviceTruckImplement.truckImplement.licensePlate}
                  </Button>
                </td>
                <td>{deviceTruckImplement.imei}</td>
                <td>{deviceTruckImplement.iccid}</td>
                <td className="text-right">
                  {/* <div className="btn-group flex-btn-group-container">
                    <Button
                      tag={Link}
                      to={`${match.url}/${deviceTruckImplement.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                      color="primary"
                      size="sm"
                      data-cy="entityEditButton"
                    >
                      <FontAwesomeIcon icon="pencil-alt" />{' '}
                      <span className="d-none d-md-inline">
                        <Translate contentKey="entity.action.edit">Edit</Translate>
                      </span>
                    </Button>
                    <Button
                      tag={Link}
                      to={`${match.url}/${deviceTruckImplement.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                      color="danger"
                      size="sm"
                      data-cy="entityDeleteButton"
                    >
                      <FontAwesomeIcon icon="trash" />{' '}
                      <span className="d-none d-md-inline">
                        <Translate contentKey="entity.action.delete">Delete</Translate>
                      </span>
                    </Button>
                  </div> */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Loading />
      )}
      {!loading && !deviceTruckImplementList.length && (
        <div className="alert alert-warning">
          <Translate contentKey="fleetSenseApp.deviceTruckImplement.home.notFound">No Device Truck Implements found</Translate>
        </div>
      )}
      {totalItems && !loading && !!deviceTruckImplementList.length ? (
        <div className="count-page">
          <Row>
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row>
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        <Fragment />
      )}
    </Fragment>
  );
};

export default DeviceTruckImplement;
